import { render, staticRenderFns } from "./commodityManage.vue?vue&type=template&id=14b69bdc&scoped=true"
import script from "./commodityManage.vue?vue&type=script&lang=js"
export * from "./commodityManage.vue?vue&type=script&lang=js"
import style0 from "./commodityManage.vue?vue&type=style&index=0&id=14b69bdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b69bdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b69bdc')) {
      api.createRecord('14b69bdc', component.options)
    } else {
      api.reload('14b69bdc', component.options)
    }
    module.hot.accept("./commodityManage.vue?vue&type=template&id=14b69bdc&scoped=true", function () {
      api.rerender('14b69bdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/mall/commodityManage.vue"
export default component.exports